@let capacity = capacity$ | async;

<div class="header-bar-card">
  <div class="header-bar-zone header-bar-zone-start">
    <nimbus-header-bar-presence></nimbus-header-bar-presence>
  </div>

  <div class="header-bar-divider"></div>

  <div class="header-bar-zone header-bar-zone-center">
    @if (capacity?.taskParallelizationEnabled) {
      @if (isCapacityCompact$ | async) {
        <nimbus-user-tp-capacity-button></nimbus-user-tp-capacity-button>
      } @else {
        <nimbus-user-tp-capacity [capacity]="capacity"></nimbus-user-tp-capacity>
      }
    }
    <nimbus-header-bar-pinned-services></nimbus-header-bar-pinned-services>
  </div>

  <div class="header-bar-zone header-bar-zone-end">
    @if (capacity?.taskParallelizationEnabled) {
      <div class="header-bar-divider"></div>
    }
    <nimbus-header-bar-services></nimbus-header-bar-services>
    <div class="header-bar-divider"></div>
    <nimbus-header-bar-help></nimbus-header-bar-help>
    <nimbus-header-bar-quick-actions [origin]="origin"></nimbus-header-bar-quick-actions>
  </div>
</div>
